import { ConnectionZoomFormVM } from '../connection-zoom-form.viewmodel';
import { TConnection } from '../../../../../../../../api/blueprints/connection.template.types';
import { zoomMeetingConfigList } from './connection-zoom-meeting-form.config';
import { ConnectionVersion } from '../../../../../../../../constants/common.constants';

export class ConnectionZoomMeetingFormVM extends ConnectionZoomFormVM {
    constructor(
        connection: TConnection,
        addConnection: (connection: TConnection) => void,
        editConnection: (connection: TConnection) => void,
        connectionVersion: ConnectionVersion,
        isAutoSyncLimitReached: boolean,
    ) {
        super(connection, zoomMeetingConfigList, addConnection, editConnection, connectionVersion, isAutoSyncLimitReached);
    }

}
